// const classService = {
//   1: {
//     coverImg: 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyBook/cover-whole.png',
//     learnService: '3,4,5,18',
//     name:'全程班',
//     courseId: 3149,
//   },
//   23: {
//     coverImg: 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyBook/cover-book.png',
//     learnService: '16,3,4,5,18',
//     name:'书课包',
//     courseId: 3149,
//   },
//   24: {
//     coverImg: 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyBook/cover-major.png',
//     learnService: '3,4,5,18',
//     name:'专项班',
//     courseId: 3149,
//   },
// };
const classService = {
  1: {
    coverImg: 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyBook/cover-whole.png',
    learnService: '3,4,5,18',
    name:'全程班',
    courseId: 3791,
  },
  6: {
    coverImg: 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyBook/cover-book.png',
    learnService: '16,3,4,5,18',
    name:'书课包',
    courseId: 3791,
  },
  13: {
    coverImg: 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyBook/cover-major.png',
    learnService: '3,4,5,18',
    name:'专项班',
    courseId: 3791,
  },
};
export default classService;
